<template>
  <div class="country-data">
    <section class="breadcrumb-panel">
      <div class="breadcrumb-wrapper">
        <AnalyticsNavbar
          :is-chart-file-loading="isChartFileLoading"
          @download-chart="handleDownloadChart"
        />
      </div>
    </section>
    <section>
      <RouterView
        ref="tabRef"
        v-slot="{ Component }"
      >
        <Component
          :is="Component"
          ref="routeComponent"
        />
      </RouterView>
    </section>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import AnalyticsNavbar from "@/components/AnalyticsPage/AnalyticsNavbar.vue";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useNotificationsStore } from "@/store/notifications";
import { t } from "@/controllerLK/GlobusLocalization";

const rubricStore = useRubricsStore();
const notificationStore = useNotificationsStore();

const tabRef = ref(null);
const routeComponent = ref(null);

// Флаг загрузки PDF файла.
const isChartFileLoading = ref(false);

const handleDownloadChart = async () => {
  if (routeComponent.value && typeof routeComponent.value.downloadChart === "function") {
    isChartFileLoading.value = true;
    await routeComponent.value.downloadChart();
    isChartFileLoading.value = false;
  }
};

onMounted(async () => {
  await rubricStore.getAllRubrics();
  if (!rubricStore.rubricsOnMonitoring.length) {
    window.routerLK.push("/");
    notificationStore.createNotify(t("notification_item.error.no_rubric"), "error");
  }
});
</script>

<style lang="scss" scoped>
.country-data {
  background-color: #eef1f4;
  min-height: calc(100vh - 80px);
  height: 100%;
}

.breadcrumb-panel {
  background: #fff;
  border-radius: 8px;
  height: 56px;
}

.breadcrumb-wrapper {
  border-radius: 8px;
  text-align: left;
  padding: 7px 7px 7px 12px;
  font-size: 14px;
}
</style>
